var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutterdev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 330,
    height: 280.311,
    viewBox: "0 0 330 280.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.17,
    y1: 1.143,
    x2: 0.669,
    y2: 0.458,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flutter_dev",
    "data-name": "flutter dev",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M220.341,625.433c16.642,10.675,37.431,10.133,57.42,7.632,2.791-.349,5.561-.731,8.3-1.13.016-.005.038,0,.055-.01.132-.02.264-.039.39-.054l1.693-.252-.119.261-.375.811c.136-.272.272-.538.408-.81.04-.082.085-.163.125-.245,4.71-9.326,9.359-18.982,10.116-29.383.78-10.794-3.7-22.728-13.416-27.488a19.067,19.067,0,0,0-4-1.425c-.574-.141-1.153-.249-1.738-.341a20.438,20.438,0,0,0-22.3,27.812c-8.443-7.771-7.669-21.159-5.51-32.43s4.843-23.827-1.32-33.513c-3.426-5.391-9.11-8.544-15.354-9.6-.191-.031-.383-.061-.574-.086a29.828,29.828,0,0,0-21.2,4.905c-11.395,8.071-16.692,22.492-17.913,36.4C193.07,588.879,201.421,613.3,220.341,625.433Z",
    transform: "translate(-193.042 -354.547)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M264.868,589.968a50.706,50.706,0,0,0,4.265,14.079,44.031,44.031,0,0,0,7.428,10.781,56.412,56.412,0,0,0,22.48,14.433,81.19,81.19,0,0,0,20,4.232c2.791-.349,5.561-.731,8.3-1.13.016-.005.038,0,.055-.01.132-.02.264-.04.39-.054l1.693-.252-.119.261-.375.811c.136-.272.272-.538.408-.81.04-.082.085-.163.125-.245a44.483,44.483,0,0,1-7.3-58.3c-.574-.141-1.153-.249-1.738-.341a46.935,46.935,0,0,0-3.892,7.311,45.985,45.985,0,0,0-2.419,28.78,47.013,47.013,0,0,0,13.159,22.773c-.537-.009-1.08-.023-1.611-.043-10.062-.308-20.174-1.921-29.5-5.841a52.477,52.477,0,0,1-20.5-15.047c-5.912-7.291-8.829-16.287-9.747-25.541a109.851,109.851,0,0,1,1.51-29.864,124.824,124.824,0,0,1,8.933-29.095A.9.9,0,0,0,276,525.7a.763.763,0,0,0-.574-.086.664.664,0,0,0-.418.4c-.512,1.148-1.014,2.3-1.493,3.457a126.239,126.239,0,0,0-8.27,30.131C263.788,569.58,263.283,579.968,264.868,589.968Z",
    transform: "translate(-234.32 -354.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M550.854,168.757h-1.54V126.574A24.415,24.415,0,0,0,524.9,102.159H435.527a24.415,24.415,0,0,0-24.415,24.415V357.995a24.415,24.415,0,0,0,24.415,24.415H524.9A24.415,24.415,0,0,0,549.314,358V198.783h1.54Z",
    transform: "translate(-322.221 -102.16)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M535.868,117.918H524.2a8.662,8.662,0,0,1-8.021,11.934h-51.2a8.662,8.662,0,0,1-8.02-11.934h-10.9a18.233,18.233,0,0,0-18.233,18.233V367.235a18.233,18.233,0,0,0,18.233,18.233h89.8A18.233,18.233,0,0,0,554.1,367.235h0V136.151a18.233,18.233,0,0,0-18.232-18.233Z",
    transform: "translate(-332.204 -111.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M938.826,725.874c-6.477,4.666-14.87,4.9-22.982,4.327-1.133-.08-2.258-.174-3.372-.275l-.022,0c-.054-.005-.107-.01-.158-.013l-.688-.065.054.1.169.319-.182-.318c-.018-.032-.038-.064-.056-.1-2.1-3.657-4.186-7.449-4.718-11.625-.55-4.335.995-9.243,4.81-11.373a7.7,7.7,0,0,1,1.58-.662c.228-.069.459-.126.693-.175a8.252,8.252,0,0,1,9.6,10.727c3.234-3.317,2.631-8.7,1.515-13.194s-2.471-9.5-.2-13.539a8.928,8.928,0,0,1,5.981-4.2c.076-.017.153-.033.23-.047a12.042,12.042,0,0,1,8.652,1.516c4.769,3.005,7.219,8.7,8.014,14.286C949.025,710.543,946.188,720.569,938.826,725.874Z",
    transform: "translate(-618.159 -450.466)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M943.885,711.822a20.47,20.47,0,0,1-1.413,5.769,17.775,17.775,0,0,1-2.76,4.508,22.775,22.775,0,0,1-8.748,6.308,32.775,32.775,0,0,1-7.97,2.142c-1.133-.08-2.258-.174-3.372-.275l-.022,0c-.054-.005-.107-.01-.158-.013l-.688-.065.054.1.169.319-.182-.318c-.018-.032-.038-.064-.056-.1a17.959,17.959,0,0,0,1.672-23.66c.228-.069.459-.126.693-.175a18.948,18.948,0,0,1,1.728,2.863,18.565,18.565,0,0,1,1.6,11.55,18.98,18.98,0,0,1-4.809,9.467c.216-.015.435-.033.649-.052a33.283,33.283,0,0,0,11.764-3,21.188,21.188,0,0,0,7.937-6.513,19.15,19.15,0,0,0,3.373-10.509,44.353,44.353,0,0,0-1.259-12.006,50.4,50.4,0,0,0-4.235-11.535.362.362,0,0,1,.144-.478.308.308,0,0,1,.23-.047.268.268,0,0,1,.177.152c.232.452.459.9.677,1.361a50.967,50.967,0,0,1,3.99,11.967A41.024,41.024,0,0,1,943.885,711.822Z",
    transform: "translate(-625.309 -450.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M520.1,796.573H190.9a.4.4,0,0,1,0-.806H520.1a.4.4,0,1,1,0,.806Z",
    transform: "translate(-190.5 -516.292)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M628.811,656.062h-4.94l-2.35-19.054h7.291Z",
    transform: "translate(-371.091 -380.338)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M609.708,680.793h9.527v6H603.71A6,6,0,0,1,609.708,680.793Z",
    transform: "translate(-360.457 -406.481)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M674.811,656.062h-4.94l-2.35-19.054h7.291Z",
    transform: "translate(-398.556 -380.338)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M655.708,680.793h9.527v6H649.71A6,6,0,0,1,655.708,680.793Z",
    transform: "translate(-387.922 -406.481)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M868.565,567.461a4.328,4.328,0,0,1-.831-6.585l-3.253-46.159,9.369.909.257,45.2a4.352,4.352,0,0,1-5.543,6.632Z",
    transform: "translate(-592.914 -348.485)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M818.354,675.344l-5.438-.259a1.813,1.813,0,0,1-1.727-1.8l-.38-55.023a1.814,1.814,0,0,1,2.074-1.807l21.756,3.158a1.8,1.8,0,0,1,1.553,1.781l2.8,50.985a1.813,1.813,0,0,1-1.813,1.827h-5.863a1.8,1.8,0,0,1-1.791-1.531l-3.617-22.994a1.41,1.41,0,0,0-2.793.052l-2.871,24.016a1.82,1.82,0,0,1-1.8,1.6Z",
    transform: "translate(-560.868 -409.22)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M821.3,545.857a27.369,27.369,0,0,0-10.347-3.544,1.78,1.78,0,0,1-1.23-.674,1.8,1.8,0,0,1-.375-1.371l5.213-38.7a13.385,13.385,0,0,1,7.8-10.459,13.017,13.017,0,0,1,12.65.992q.268.178.526.364a13.369,13.369,0,0,1,5.092,13.931c-3.2,13.077-4.295,34.516-4.482,38.681a1.8,1.8,0,0,1-1.176,1.614,18.166,18.166,0,0,1-6.135,1.092A15.362,15.362,0,0,1,821.3,545.857Z",
    transform: "translate(-559.983 -333.679)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M867.607,524.933a1.806,1.806,0,0,1-.749-1.37l-.687-12.441a5,5,0,0,1,9.81-1.582L879,520.663a1.815,1.815,0,0,1-1.276,2.224l-8.579,2.326A1.806,1.806,0,0,1,867.607,524.933Z",
    transform: "translate(-593.918 -343.192)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 9.896,
    cy: 9.896,
    r: 9.896,
    transform: "translate(255.779 132.381)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M765.426,517.9a4.991,4.991,0,0,1-3.094-1.067l-16.838-13.283a4.116,4.116,0,0,1-.418.123,4.441,4.441,0,0,1-3.553-.682,4.433,4.433,0,1,1,6.853-4.647h0a4.268,4.268,0,0,1,.092.585l17.117,9.875,4.26-2.452,4.719,6.178-6.243,4.45A4.986,4.986,0,0,1,765.426,517.9Z",
    transform: "translate(-518.368 -336.666)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M805.569,510.43a1.806,1.806,0,0,1,.521-1.472l8.809-8.811a5,5,0,0,1,7.723,6.252l-6.274,9.667a1.815,1.815,0,0,1-2.508.534l-7.456-4.839A1.806,1.806,0,0,1,805.569,510.43Z",
    transform: "translate(-557.733 -338.912)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M833.519,444.577a1.6,1.6,0,0,0,2.293.132,17.9,17.9,0,0,0,5.106-6.668,11.877,11.877,0,0,0,.011-9.684,13.364,13.364,0,0,0-5.678-5.241,9.265,9.265,0,0,0-2.759-1.166,3.624,3.624,0,0,0-2.883.567,3.04,3.04,0,0,0-1.16,2.912,9.007,9.007,0,0,0-3.95-2.964,4.58,4.58,0,0,0-3.044-.2,5.571,5.571,0,0,0-3.066,3.46,7.712,7.712,0,0,0-.506,3.733,4.484,4.484,0,0,0,1.72,3.091,4.842,4.842,0,0,0,4.01.366,31.41,31.41,0,0,1,4.038-1.124,3.8,3.8,0,0,1,3.718,1.422,6.887,6.887,0,0,1,.831,3.086l.612,5.64a7.471,7.471,0,0,0,.515,2.353A1.311,1.311,0,0,0,833.519,444.577Z",
    transform: "translate(-565.063 -293.043)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(111.738 190.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M467.814,574.842h13.652v2.672H470.585v8.08h9.828v2.638h-9.828v10.223h-2.77Z",
    transform: "translate(-467.814 -574.842)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M509.881,574.842h2.8v23.61h-2.8Z",
    transform: "translate(-492.931 -574.842)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M528.422,607.264a7.182,7.182,0,0,1-1.6-4.98V591.7h2.8v10.157a4.917,4.917,0,0,0,1.088,3.529,3.9,3.9,0,0,0,2.934,1.122,4.337,4.337,0,0,0,2.521-.758,5.139,5.139,0,0,0,1.714-1.979,5.661,5.661,0,0,0,.61-2.573v-9.5h2.8v16.818h-2.672v-2.441h-.132a5.554,5.554,0,0,1-2.21,2.111,6.47,6.47,0,0,1-3.233.857A5.9,5.9,0,0,1,528.422,607.264Z",
    transform: "translate(-503.046 -584.907)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M576.33,601.673a4.306,4.306,0,0,1-1.467-.906,4.124,4.124,0,0,1-.989-1.477,5.6,5.6,0,0,1-.33-2.049V587.2H570.61v-2.539h2.934v-4.749h2.8v4.749h4.089V587.2h-4.09v9.371a3.384,3.384,0,0,0,.527,2.09,2.24,2.24,0,0,0,1.815.743,3.41,3.41,0,0,0,1.846-.561v2.737a4.3,4.3,0,0,1-1,.33,7.15,7.15,0,0,1-1.3.1,5.3,5.3,0,0,1-1.9-.338Z",
    transform: "translate(-529.19 -577.87)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M605.87,601.673a4.307,4.307,0,0,1-1.467-.906,4.125,4.125,0,0,1-.989-1.477,5.6,5.6,0,0,1-.33-2.049V587.2H600.15v-2.539h2.934v-4.749h2.8v4.749h4.09V587.2h-4.089v9.371a3.385,3.385,0,0,0,.527,2.09,2.24,2.24,0,0,0,1.815.743,3.409,3.409,0,0,0,1.846-.561v2.737a4.3,4.3,0,0,1-1,.33,7.156,7.156,0,0,1-1.3.1A5.319,5.319,0,0,1,605.87,601.673Z",
    transform: "translate(-546.828 -577.87)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M633.015,607.1a8.006,8.006,0,0,1-2.983-3.181,9.631,9.631,0,0,1-1.072-4.567,10.029,10.029,0,0,1,1-4.484,8.112,8.112,0,0,1,2.854-3.264,7.6,7.6,0,0,1,4.287-1.22,8.1,8.1,0,0,1,4.287,1.1,7.33,7.33,0,0,1,2.786,3.051,9.822,9.822,0,0,1,.974,4.453,3.322,3.322,0,0,1-.1.857H631.764a6.64,6.64,0,0,0,.924,3.233,5.371,5.371,0,0,0,2.093,1.979,5.664,5.664,0,0,0,2.654.66,5.473,5.473,0,0,0,4.98-3.033l2.373,1.155a8.454,8.454,0,0,1-2.952,3.233A8.872,8.872,0,0,1,633.015,607.1Zm9.166-9.563a5.442,5.442,0,0,0-.595-2.111,4.531,4.531,0,0,0-1.664-1.781,5.215,5.215,0,0,0-2.854-.724,4.738,4.738,0,0,0-3.347,1.27,6.115,6.115,0,0,0-1.8,3.347Z",
    transform: "translate(-564.028 -584.123)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M677.24,590.913h2.672v2.7h.133a4.573,4.573,0,0,1,1.914-2.308,5.36,5.36,0,0,1,2.968-.924,4.9,4.9,0,0,1,1.979.364v3a5.253,5.253,0,0,0-2.373-.527,3.919,3.919,0,0,0-2.243.693,5.013,5.013,0,0,0-1.633,1.867,5.389,5.389,0,0,0-.61,2.529v9.42h-2.8V590.913Z",
    transform: "translate(-592.856 -584.12)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M399.623,337.858l36.688,36.861-34.652-.4-12.894-12.894Z",
    transform: "translate(-232.12 -201.725)",
    fill: "#01579b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M414.493,359.949l-25.728,8.624,15.741-18.739Z",
    transform: "translate(-232.12 -208.875)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M371.886,149.89l-73.345,73.353-17.266-17.262,56.1-56.092Z",
    transform: "translate(-167.941 -89.495)",
    fill: "#54c5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M345.265,309.06l30.22-30.22h34.652l-47.546,47.143Z",
    transform: "translate(-206.147 -166.487)",
    fill: "#54c5f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M362.928,310.52l17.265,17.257-17.1,17.322-17.326-16.923Z",
    transform: "translate(-206.446 -185.402)",
    fill: "#29b6f6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterdev);
export default __webpack_public_path__ + "static/media/flutter dev.60af56e548cb5dc408061387c720796b.svg";
export { ForwardRef as ReactComponent };